<template>
<div class="products-collection-component container-padded">
  <h1 class="products-collection-title">
    {{ collectionTitle }}
    <i v-if="products.loading" class="fad fa-spinner-third fa-spin"></i>
  </h1>
  <div class="products-list-wrapper">
    <products-list v-if="hasProducts"
                   source="products_collection_page"
                   :products="products.data"
    />
    <div v-if="!hasProducts && !products.loading && productsRequestQuery" class="empty-products-list">
      <h2 class="empty-products-list-heading">Ничего не найдено</h2>
      <p>В этой коллекции нет ни одного товара.</p>
    </div>
  </div>
</div>
</template>

<script>
import axios from '@/zenky'
import config from '@/config'
import ProductsList from '@/components/products/ProductsList'

export default {
  props: {
    collectionId: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: false,
      default: '',
    },

    count: {
      type: Number,
      required: false,
      default: -1,
    },
  },

  components: {
    ProductsList,
  },

  created() {
    this.loadCollection();
  },

  computed: {
    collectionTitle() {
      if (this.title) {
        return this.title
      } else if (this.collection.ready) {
        return this.collection.name
      }

      return 'Товары'
    },

    productsRequestQuery() {
      const city_id = this.$store.state.store.activeCityId;
      if (!city_id) {
        return null;
      }
      return {
        page: 1,
        count: this.count > 0 ? this.count : 999,
        with: config.includes.productsList,
        collection_id: this.collectionId,
        city_id,
      }
    },

    hasProducts() {
      return this.products.ready && this.products.data.length > 0
    }
  },

  methods: {
    loadCollection() {
      if (this.collection.loading) {
        return
      }

      this.collection.loading = true
      this.collection.ready = false

      axios.get(`products-collections/${this.collectionId}?with=media`)
        .then(({ data }) => {
          this.collection.loading = false
          this.collection.ready = true
          this.collection.data = data.data
        })
        .catch(err => {
          this.collection.loading = false
          this.collection.ready = false
          this.collection.data = {}
          console.error(err)
        })
    },

    loadProducts() {
      if (this.products.loading) {
        return
      }

      this.products.loading = true
      this.products.ready = false

      axios.get('products', { params: this.productsRequestQuery })
        .then(({ data }) => {
          this.products.loading = false
          this.products.ready = true
          this.products.data = data.data
        })
        .catch(err => {
          this.products.loading = false
          this.products.ready = false
          this.products.data = {}
          console.error(err)
        })
    }
  },

  watch: {
    productsRequestQuery: {
      immediate: true,
      handler(n) {
        if (n !== null) {
          this.loadProducts();
        }
      },
    },
  },

  data() {
    return {
      collection: {
        loading: false,
        ready: false,
        data: {},
      },
      products: {
        loading: false,
        ready: false,
        data: [],
      },
    }
  }
}
</script>

<style lang="less">
@import '~@/assets/less/components/empty-products-list';
@import '~@/assets/less/components/products-list-header';

.products-collection-component {
  @apply overflow-hidden; // So `DistortedButton.vue` does not create horizontal scroll.

  .products-collection-title:extend(.products-list-header) {
    @apply mb-4;
  }
}
</style>
